/**
 * @file Intro Image.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import debounce from 'just-debounce';

/**
 * Intro Image component.
 */
const vIntroImage = () => {
	const introImage = document.querySelector('.v-intro-image');
	const imageScroller = document.querySelector('.v-image-scroller');

	if (!introImage) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	if (!introImage.classList.contains('v-intro-image--to-scroller')) {
		ScrollTrigger.saveStyles(['.v-intro-image__content', '.v-intro-image__background']);
		ScrollTrigger.matchMedia({
			'(min-width: 1025px)': () => {
				gsap.timeline({
					defaults:      { ease: 'sine.out' },
					scrollTrigger: {
						trigger: '.v-intro-image__content',
						start:   'center center',
						end:     'bottom top',
						scrub:   true,
					},
				})
					.to('.v-intro-image__content', {
						'--scale': '5%',
					})
					.to('.v-intro-image__background', {
						y: -200,
					}, '<');
			},
		});
	}

	if (!imageScroller || !introImage.classList.contains('v-intro-image--to-scroller')) {
		return;
	}

	const scrollerBackground = imageScroller.querySelector('.v-image-scroller__background');
	const scrollerImages = imageScroller.querySelector('.v-image-scroller__images');
	const image = introImage.querySelector('.v-intro-image__image');
	const isMobile = matchMedia('(max-width: 850px)');
	let introDescend;

	/**
	 * Initialize background descend animation.
	 */
	const initIntroDescend = () => {
		if (isMobile.matches) return;
		const backgroundHeight = scrollerBackground.offsetHeight;
		const imagesHeight = scrollerImages.offsetHeight;
		const imageScrollerFromTop = imageScroller.offsetTop;
		const imageScrollerPaddingTop = parseInt(getComputedStyle(imageScroller).paddingTop, 10);
		const imageScrollerContentTop = imageScrollerFromTop + imageScrollerPaddingTop;
		const titleHeight = backgroundHeight - imagesHeight;
		const imageCenter = imageScrollerPaddingTop + titleHeight + (imagesHeight / 2) + 100;

		const delta = imageScrollerContentTop + titleHeight - introImage.offsetTop + 100;

		introDescend = gsap.timeline({
			defaults:      { ease: 'sine.out' },
			scrollTrigger: {
				startTrigger: 'body',
				start:        'top top',
				endTrigger:   imageScroller,
				end:          `${imageCenter}px center`,
				scrub:        true,
				onLeave:      () => {
					image.classList.add('v-intro-image__image--hidden');
					scrollerImages.classList.add('v-image-scroller__images--active');
				},
				onEnterBack: () => {
					image.classList.remove('v-intro-image__image--hidden');
					scrollerImages.classList.remove('v-image-scroller__images--active');
				},
			},
		})
			.to(image, {
				y: delta,
			})
			.to('.v-intro-image__content', {
				y:         delta * 0.3,
				'--scale': '0%',
			}, '<');
	};
	initIntroDescend();

	window.addEventListener('resize', debounce(() => {
		if (introDescend) {
			if (introDescend.scrollTrigger) {
				introDescend.scrollTrigger.kill();
			}
			introDescend.kill();
		}
		initIntroDescend();
	}, 100));
};

export default vIntroImage;
